import { combineReducers } from "redux";
import commonReducer from "../../commonReducer/commonReducer";
import drivingMarketParamsReducer from "../common/params";
import weekHighLow from "./weekHighLow";
export default combineReducers({
    reducersData: weekHighLow,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
